import React from 'react';
import TagManagementMainTabNavbar from '../TagManagementTabMainNavbar';
import TagManagementTabMainTrendKeywordList from '../TagManagementTabMainTrendKeywordList';
import TagManagementTabMainFollowSelectedList from '../TagManagementTabMainFollowSelectedList';
import { TAG_TAB_MAIN_SECTION_TYPE } from '../../../../../constants/service/app/tagConstants';
import './TagManagementTabMainWrap.scss';

const TagManagementTabMainWrap = (props) => {
  const {
    tagTabMain,
    onSubmit,
    getTagTabMainContentsList,
    selectTagTabMainContentsList,
    tagTabMainPreview,
    onDragEndSelectTagTabMainContentsList,
    getRelatedTagList,
    getTagTabMainAllListExcelDownload,
    getTagTabMainSelectedListExcelDownload,
    setTagTabMainExcelUpload,
  } = props;

  return (
    <div className="tag-management-tab-main-wrap">
      {/* 하단 네브바 */}
      <TagManagementMainTabNavbar onSubmit={onSubmit} tagTabMainPreview={tagTabMainPreview} />

      {/*트렌드 키워드 리스트*/}
      <TagManagementTabMainTrendKeywordList
        tagTrendKeywordList={tagTabMain[TAG_TAB_MAIN_SECTION_TYPE.TAG_TEND_KEYWORD_LIST]}
        getTagTabMainContentsList={getTagTabMainContentsList}
        selectTagTabMainContentsList={selectTagTabMainContentsList}
        onDragEndSelectTagTabMainContentsList={onDragEndSelectTagTabMainContentsList}
        getRelatedTagList={getRelatedTagList}
        getTagTabMainAllListExcelDownload={getTagTabMainAllListExcelDownload}
        getTagTabMainSelectedListExcelDownload={getTagTabMainSelectedListExcelDownload}
        setTagTabMainExcelUpload={setTagTabMainExcelUpload}
      />

      {/*미리 선정된 팔로우한 태그 리스트*/}
      <TagManagementTabMainFollowSelectedList
        tagFollowSelectedList={tagTabMain[TAG_TAB_MAIN_SECTION_TYPE.TAG_FOLLOW_SELECTED_LIST]}
        getTagTabMainContentsList={getTagTabMainContentsList}
        selectTagTabMainContentsList={selectTagTabMainContentsList}
        onDragEndSelectTagTabMainContentsList={onDragEndSelectTagTabMainContentsList}
        getRelatedTagList={getRelatedTagList}
        getTagTabMainAllListExcelDownload={getTagTabMainAllListExcelDownload}
        getTagTabMainSelectedListExcelDownload={getTagTabMainSelectedListExcelDownload}
        setTagTabMainExcelUpload={setTagTabMainExcelUpload}
      />
    </div>
  );
};

export default TagManagementTabMainWrap;
